<phdsoft-window [options]="optionsWindow" (ok)="confirm()" (cancel)="cancel()">
  <ng-container header style="height: 40px;">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5">
      {{ options.title }}
    </div>
  </ng-container>
  <div content class="content" style="width: 270px; height: 110px;">
    <div fxLayout="column">
      <div>
        <p class="FontBIG">{{ options.question }}</p>
      </div>
      <div>
        <small>{{ options.item }}</small>
        <br>
      </div>
    </div>
  </div>
</phdsoft-window>

